import { render, staticRenderFns } from "./Company Logo.vue?vue&type=template&id=31f74705&scoped=true&"
import script from "./Company Logo.vue?vue&type=script&lang=js&"
export * from "./Company Logo.vue?vue&type=script&lang=js&"
import style0 from "./Company Logo.vue?vue&type=style&index=0&id=31f74705&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f74705",
  null
  
)

export default component.exports